/**
 * TODO: This file probably duplicates functionality we have from packages/core/geo_utils/src/count_distance.ts
 *  Check usages of below functions and compare, if possible, remove duplicates
 */

type ICoordinates = [number, number];

const asin = Math.asin;
const cos = Math.cos;
const sin = Math.sin;
const sqrt = Math.sqrt;
const PI = Math.PI;

// equatorial mean radius of Earth (in meters)
const EARTH_RADIUS = 6378137;

const squared = (x: number) => x * x;
const hav = (x: number) => squared(sin(x / 2));
const toRadians = (angleDegrees: number) => (angleDegrees * PI) / 180.0;

// hav(theta) = hav(bLat - aLat) + cos(aLat) * cos(bLat) * hav(bLon - aLon)
const haversineDistance = (a: ICoordinates, b: ICoordinates) => {
    const aLat = toRadians(a[1]);
    const bLat = toRadians(b[1]);
    const aLng = toRadians(a[0]);
    const bLng = toRadians(b[0]);

    const ht = hav(bLat - aLat) + cos(aLat) * cos(bLat) * hav(bLng - aLng);
    return 2 * EARTH_RADIUS * asin(sqrt(ht));
};

export const calcCircleOnMapRadius = (centerCoordinates: ICoordinates, innerMarkersCoordinates: ICoordinates[], extraBufferRadius = 0) => {
    const distancesInStraightLineBetweenCenterAndMarkers = innerMarkersCoordinates.map((markerCoordinates) =>
        haversineDistance(centerCoordinates, markerCoordinates)
    );
    const maxValue = distancesInStraightLineBetweenCenterAndMarkers.length > 0 ? Math.max(...distancesInStraightLineBetweenCenterAndMarkers) : 0;

    return maxValue + extraBufferRadius;
};
/**
 * TODO: This file probably duplicates functionality we have from packages/core/geo_utils/src/count_distance.ts
 *  Check usages of below functions and compare, if possible, remove duplicates
 */

type ICoordinates = [number, number];

const asin = Math.asin;
const cos = Math.cos;
const sin = Math.sin;
const sqrt = Math.sqrt;
const PI = Math.PI;

// equatorial mean radius of Earth (in meters)
const EARTH_RADIUS = 6378137;

const squared = (x: number) => x * x;
const hav = (x: number) => squared(sin(x / 2));
const toRadians = (angleDegrees: number) => (angleDegrees * PI) / 180.0;

// hav(theta) = hav(bLat - aLat) + cos(aLat) * cos(bLat) * hav(bLon - aLon)
const haversineDistance = (a: ICoordinates, b: ICoordinates) => {
    const aLat = toRadians(a[1]);
    const bLat = toRadians(b[1]);
    const aLng = toRadians(a[0]);
    const bLng = toRadians(b[0]);

    const ht = hav(bLat - aLat) + cos(aLat) * cos(bLat) * hav(bLng - aLng);
    return 2 * EARTH_RADIUS * asin(sqrt(ht));
};

export const calcCircleOnMapRadius = (centerCoordinates: ICoordinates, innerMarkersCoordinates: ICoordinates[], extraBufferRadius = 0) => {
    const distancesInStraightLineBetweenCenterAndMarkers = innerMarkersCoordinates.map((markerCoordinates) =>
        haversineDistance(centerCoordinates, markerCoordinates)
    );
    const maxValue = distancesInStraightLineBetweenCenterAndMarkers.length > 0 ? Math.max(...distancesInStraightLineBetweenCenterAndMarkers) : 0;

    return maxValue + extraBufferRadius;
};
